import { Box, Button, useTheme } from '@hover/blueprint';
import React from 'react';

import { Logo } from 'src/shared/components';

import { useProTranslate } from '../hooks';

export const Header = () => {
  const t = useProTranslate();
  const { zIndices } = useTheme();

  return (
    <Box
      alignItems="center"
      background="neutral.0"
      justifyContent="space-between"
      paddingX={{ base: 500, tablet: 800 }}
      paddingY={{ base: 200, tablet: 600 }}
      position="sticky"
      top={0}
      width={1}
      zIndex={zIndices.sticky}
    >
      <Logo color="inherit" />
      <Button variant="tertiary">{t('getInTouch')}</Button>
    </Box>
  );
};
